import LegalHeroV2 from './LegalHeroV2';
import LegalTabsV2 from './LegalTabsV2';
import LegalDocV2 from './LegalDocV2';
import LegalContactV2 from './LegalContactV2';
import { docMeta, type LegalDocKind } from './types';

type Props = {
  kind: LegalDocKind;
  subtitle: string;
  lastUpdated: string;
  content: string;
  contactTitle?: string;
  contactDesc?: string;
  contactEmail?: string;
};

export default function LegalPageLayoutV2({
  kind,
  subtitle,
  lastUpdated,
  content,
  contactTitle,
  contactDesc,
  contactEmail,
}: Props) {
  const meta = docMeta(kind);
  return (
    <>
      <LegalHeroV2 lastUpdated={lastUpdated} />
      <LegalTabsV2 active={kind} />
      <LegalDocV2 meta={meta} subtitle={subtitle} lastUpdated={lastUpdated} content={content} />
      <LegalContactV2 title={contactTitle} desc={contactDesc} email={contactEmail} />
    </>
  );
}
